import React from 'react';

const ProjectsTableSkeleton = ({ count = 6 }) => (
  <div className="space-y-3">
    {Array.from({ length: count }, (_, index) => (
      <div
        key={`project-table-skeleton-${index + 1}`}
        className="grid animate-pulse gap-4 rounded-xl border border-border/40 bg-card/20 px-4 py-4 grid-cols-[minmax(0,2fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1.2fr)] items-center"
      >
        <div className="flex min-w-0 items-start gap-3">
          <div className="h-9 w-9 shrink-0 rounded-xl bg-muted/60" />
          <div className="min-w-0 flex-1 space-y-2">
            <div className="h-4 w-2/5 rounded-full bg-muted/60" />
            <div className="h-3 w-4/5 rounded-full bg-muted/45" />
          </div>
        </div>

        <div className="inline-flex min-w-[132px] items-center gap-2 rounded-[8px] border border-border/40 bg-secondary/45 px-[10px] py-[6px]">
          <div className="h-7 w-7 shrink-0 rounded-full bg-muted/55" />
          <div className="min-w-0 space-y-1.5">
            <div className="h-2.5 w-12 rounded-full bg-muted/45" />
            <div className="h-3.5 w-16 rounded-full bg-muted/60" />
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="h-7 w-8 rounded-full bg-muted/60" />
          <div className="space-y-1.5">
            <div className="h-2.5 w-14 rounded-full bg-muted/45" />
            <div className="h-3 w-12 rounded-full bg-muted/40" />
          </div>
        </div>

        <div className="justify-self-end">
          <div className="flex rounded-xl shadow-xs">
            <div className="h-9 w-32 rounded-l-xl bg-muted/60" />
            <div className="h-9 w-10 rounded-r-xl bg-muted/50" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default ProjectsTableSkeleton;
